var map = {
	"./en/Assessments.json": "f0d6",
	"./en/Clients.json": "fa70",
	"./en/Common.json": "180b",
	"./en/Customers.json": "73dd",
	"./en/Dashboard.json": "68aa",
	"./en/DemoPage.json": "ca35",
	"./en/ForgotPassword.json": "04aa",
	"./en/Login.json": "6fda",
	"./en/Menu.json": "ff83",
	"./en/Metrics.json": "7516",
	"./en/Register.json": "a300",
	"./en/Reports.json": "00c4",
	"./en/ResetPassword.json": "8d44",
	"./en/Tabs.json": "f95e",
	"./en/UserAccount.json": "35be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";